import { AssortmentItemTagDTO, AssortmentTagDTO, OrgUnitTypeDTO } from '../dto';

export interface AssortmentTagProps {
  id: number;
  assortmentId: number;
  name: string;
  count: number;
  tagLocation?: OrgUnitTypeDTO;
  sendEvents?: boolean;
  visibleToMembers?: boolean;
  selectableByMembers?: boolean;
  validFrom: Date;
  validTo?: Date;
}

export class AssortmentTag {
  id: number;
  assortmentId: number;
  name: string;
  count: number;
  tagLocation?: OrgUnitTypeDTO;
  sendEvents?: boolean;
  visibleToMembers?: boolean;
  selectableByMembers?: boolean;
  validFrom: Date;
  validTo?: Date;

  constructor({
    id,
    assortmentId,
    name,
    count,
    tagLocation,
    sendEvents,
    visibleToMembers,
    selectableByMembers,
    validFrom,
    validTo,
  }: AssortmentTagProps) {
    this.id = id;
    this.assortmentId = assortmentId;
    this.name = name;
    this.count = count;
    this.tagLocation = tagLocation;
    this.sendEvents = sendEvents;
    this.visibleToMembers = visibleToMembers;
    this.selectableByMembers = selectableByMembers;
    this.validFrom = validFrom;
    this.validTo = validTo;
  }

  static fromDTO = (dto: AssortmentTagDTO): AssortmentTag =>
    new AssortmentTag({
      id: dto.id,
      assortmentId: dto.assortmentId,
      name: dto.name,
      count: dto.count,
      tagLocation: dto.tagLocation,
      sendEvents: dto.sendEvents,
      visibleToMembers: dto.visibleToMembers,
      selectableByMembers: dto.selectableByMembers,
      validFrom: new Date(dto.validFrom),
      validTo: dto.validTo ? new Date(dto.validTo) : undefined,
    });
}

export interface AssortmentItemTagProps {
  tagId: number;
  tagName: string;
}

export class AssortmentItemTag {
  tagId: number;
  tagName: string;

  constructor({ tagId, tagName }: AssortmentItemTagProps) {
    this.tagId = tagId;
    this.tagName = tagName;
  }

  static fromDTO = (dto: AssortmentItemTagDTO): AssortmentItemTag =>
    new AssortmentItemTag({
      tagId: dto.id,
      tagName: dto.name,
    });
}
